function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M36.985 0H7.963C7.155 0 6.5.655 6.5 1.926V55c0 .345.655 1 1.463 1h40.074c.808 0 1.463-.655 1.463-1V12.978c0-.696-.093-.92-.257-1.085L37.607.257A.884.884 0 0036.985 0z",
  fill: "#e9e9e0"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#d9d7ca",
  d: "M37.5.151V12h11.849z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M48.037 56H7.963A1.463 1.463 0 016.5 54.537V39h43v15.537c0 .808-.655 1.463-1.463 1.463z",
  fill: "#e96360"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.947 47.682c0 .829-.089 1.538-.267 2.126s-.403 1.08-.677 1.477-.581.709-.923.937-.672.398-.991.513a4.094 4.094 0 01-.875.219c-.264.03-.46.046-.587.046h-3.814V42.924h3.035c.848 0 1.593.135 2.235.403s1.176.627 1.6 1.073.74.955.95 1.524c.209.57.314 1.156.314 1.758zm-4.867 4.115c1.112 0 1.914-.355 2.406-1.066s.738-1.741.738-3.09c0-.419-.05-.834-.15-1.244-.101-.41-.294-.781-.581-1.114s-.677-.602-1.169-.807-1.13-.308-1.914-.308h-.957v7.629h1.627zM30.098 47.695c.209.027.433.096.67.205.237.109.458.265.663.465s.376.444.513.731.205.617.205.991c0 .456-.068.848-.205 1.176s-.308.6-.513.813-.429.383-.67.506a3.873 3.873 0 01-.697.28 3.106 3.106 0 01-.595.116 4.976 4.976 0 01-.342.022H25.34V42.924h2.898c.428 0 .843.05 1.244.15.401.101.756.26 1.066.479.31.219.556.504.738.854.182.351.273.768.273 1.251a2.1 2.1 0 01-.137.772c-.091.232-.205.436-.342.608s-.294.316-.472.431-.346.19-.51.226zm-1.901-.465c.2 0 .405-.005.615-.014.209-.009.405-.06.588-.15.182-.091.33-.246.444-.465.114-.219.171-.533.171-.943 0-.164-.023-.335-.068-.513-.046-.178-.137-.34-.273-.485s-.333-.265-.588-.355c-.255-.091-.593-.137-1.012-.137H26.98v3.063h1.217zm.834 4.567c.483 0 .861-.155 1.135-.465s.41-.725.41-1.244c0-.492-.142-.907-.424-1.244-.283-.337-.697-.506-1.244-.506H26.98v3.459h2.051zM36.168 44.168v3.172h4.211v1.121h-4.211V53H34.5V42.924h6.303v1.244h-4.635z"
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M24.5 16v-4h-12v22h33V16h-21zm-10-2h8v2h-8v-2zm0 4h8v2h-8v-2zm0 4h8v2h-8v-2zm0 4h8v2h-8v-2zm8 6h-8v-2h8v2zm21 0h-19v-2h19v2zm0-4h-19v-2h19v2zm0-4h-19v-2h19v2zm-19-4v-2h19v2h-19z",
  fill: "#c8bdb8"
});

var SvgDbf = function SvgDbf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 56 56"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
};

export default SvgDbf;